import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'

import { Button } from '../../../../components/common/Button'
import { Select } from '../../../../components/common/Select'
import {
  Container,
  Footer,
  SelectContainer,
  Table,
  TableCell,
  TableCellEmpty,
  TableHeader,
} from './styles'

import api from '../../../../services/api'

import { NotePencil } from '@phosphor-icons/react'

import { ContextResidents } from '../../../../context/context_residents'

interface AddressProps {
  address: string
  state: string
  city: string
  burgh: string
  zipcode: string
  latitude: number
  longitude: number
}

interface VehicleProps {
  id: string
  vehicle: string
  color: string
  plate: string
  type: string
}

interface ResidentsProps {
  id: string
  active: boolean
  name: string
  base: string
  outpost: string
  Address: AddressProps[]
  Vehicles: VehicleProps[]
  LinkedUsers: []
}

interface TableResidentsProps {
  openModalActive: Dispatch<SetStateAction<boolean>>
  openModalInactive: Dispatch<SetStateAction<boolean>>
  updateTable?: boolean
}

export const TableResidents = ({
  openModalActive,
  openModalInactive,
  updateTable,
}: TableResidentsProps) => {
  const { startEditing } = useContext(ContextResidents)

  const [data, setData] = useState<ResidentsProps[]>()
  const [active, setActive] = useState('actives')
  const handlerState = (setValue) => {
    setValue((prev) => !prev)
  }

  useEffect(() => {
    api
      .post('/v1/dashboard/residents/table', {
        active: active === 'actives',
      })
      .then((response) => {
        console.log('data', response.data)
        setData(response.data)
      })
      .catch((error) => {
        console.log(error.response.data.statusCode)
      })
  }, [active])

  useEffect(() => {
    api
      .post('/v1/dashboard/residents/table', {
        active: active === 'actives',
      })
      .then((response) => {
        console.log('data', response.data)
        setData(response.data)
      })
      .catch((error) => {
        console.log(error.response.data.statusCode)
      })
  }, [updateTable])

  return (
    <Container>
      <SelectContainer>
        <Select
          bordercolor="#CECECE"
          backgroundcolor="#f7f7f7"
          currentOption={active}
          label={{ title: '', htmlFor: '' }}
          onchange={(e) => setActive(e.target.value)}
          data={[
            { id: 'actives', value: 'Ver usuários ativos' },
            { id: 'inactives', value: 'Ver usuários inativos' },
          ]}
        />
      </SelectContainer>
      <Table>
        <thead>
          <tr>
            <TableHeader>Nome de usuário</TableHeader>
            <TableHeader>Base</TableHeader>
            <TableHeader>Posto</TableHeader>
            <TableHeader>Residência</TableHeader>
            <TableHeader>Veículos cadastrados</TableHeader>
            <TableHeader>Moradores vinculados</TableHeader>
            <TableHeader>Ver dados</TableHeader>
          </tr>
        </thead>
        <tbody>
          {data === undefined || data.length === 0 ? (
            <tr>
              <TableCellEmpty colSpan={7}>
                Nenhum dado encontrado
              </TableCellEmpty>
            </tr>
          ) : (
            data?.map((val) => {
              return (
                <tr key={val.id}>
                  <TableCell>{val.name}</TableCell>
                  <TableCell>{val.base}</TableCell>
                  <TableCell>{val.outpost}</TableCell>
                  <TableCell>
                    {val.Address.map((address) => address.address).join('/ ')}
                  </TableCell>
                  <TableCell>{val.Vehicle.length}</TableCell>
                  <TableCell>{val.LinkedUsers.length}</TableCell>
                  <TableCell>
                    <Button.Root
                      onClick={() => {
                        startEditing(val)
                        active === 'actives'
                          ? handlerState(openModalActive)
                          : handlerState(openModalInactive)
                      }}
                      backgroundColor="#00517D"
                      type="button"
                      padding="0"
                    >
                      <Button.Content title="Editar" color="#fff" />
                      <Button.Icon>
                        <NotePencil size={24} color="#fff" weight="fill" />
                      </Button.Icon>
                    </Button.Root>
                  </TableCell>
                </tr>
              )
            })
          )}
        </tbody>
      </Table>
      <Footer>
        Listando {data?.length !== 0 ? data?.length : '0'} usuário(s)
      </Footer>
    </Container>
  )
}
